import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import easing from 'ui/styles/easing'

export default class FAQ extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    active: PropTypes.bool,
    index: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired
  }

  state = {
    contentHeight: 0,
  }

  componentDidMount() {
    this.updateHeight()
    window.addEventListener('resize', this.updateHeight)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateHeight)
  }

  updateHeight = () => {
    const { contentHeight } = this.state
    //Check if clientHeight is the same as contentHeight. In the prop 1px is substracted for the sake of making it different height and achieving (almost) 100% height of that element ¯\_(ツ)_/¯ 
    if (this.content) {
      if (this.content.clientHeight !== contentHeight && this.props.img !== null) {
        this.setState({ contentHeight: this.content.clientHeight*2})
        this.content.style.height="100%";
      }
      else {
        this.setState({ contentHeight: this.content.clientHeight })
      }
    }
  }

  render() {
    const { title, text, active, index, onClick, img } = this.props
    const { contentHeight } = this.state

    return (
      <Content index={index} key={index} id={`accordion-item-${index}`}>
        <Title onClick={onClick} index={index}>
          <span>{title}</span>
          <Icon open={active}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 13 13"
            >
              <g
                fill="none"
                fillRule="evenodd"
                stroke="#141414"
                strokeLinecap="square"
              >
                <path d="M12 6.5H1" />
                <path d="M6.5 1v11" />
              </g>
            </svg>
          </Icon>
        </Title>
        <ItemContentWrapper height={active ? contentHeight : 0}>
          <ItemContent innerRef={(el) => (this.content = el)}>
            <Text
              dangerouslySetInnerHTML={{
                __html: text,
              }}
            />
            {img &&(
              <Img image={img && img.sourceUrl}/>
            )}
          </ItemContent>
        </ItemContentWrapper>
      </Content>
    )
  }
}

// Styles

const Content = styled.div`
  overflow: hidden;
  margin-bottom: 10px;
`

const ItemContent = styled.div`
  display: flex;
`

const Img = styled.div`
background: url(${(props) => props.image}) center / cover;
width: 100%;
background-size: contain;
background-repeat: no-repeat;
`

const Title = styled.div`
  color: black;
  padding: 1em;
  cursor: pointer;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
  background-color: rgb(245, 245, 245);
`

const Icon = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 25px;
  border: 1px solid #878585;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    transition: transform 0.3s ${easing.easeOutCubic};
    transform: rotate(${(props) => (props.open ? 135 : 0)}deg);
  }
`

const Text = styled.div`
  color: ${(props) => props.theme.colors.text};
  padding: 1em;
  font-weight: 300;

`

const ItemContentWrapper = styled.div`
  overflow: hidden;
  height: ${(props) => props.height}px;
  transition: height 0.3s ${easing.easeOutCubic};
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/FAQ/Item.js